export const LOAD_TRAINING                      = 'LOAD_TRAINING';
export const LOAD_TRAINING_SUCCESS              = 'LOAD_TRAINING_SUCCESS';
export const LOAD_TRAINING_ERROR                = 'LOAD_TRAINING_ERROR';

export const CREATE_TRAINING                    = 'LOAD_TRAINING';
export const CREATE_TRAINING_SUCCESS            = 'LOAD_TRAINING_SUCCESS';
export const CREATE_TRAINING_ERROR              = 'LOAD_TRAINING_ERROR';

export const UPDATE_TRAINING                    = 'LOAD_TRAINING';
export const UPDATE_TRAINING_SUCCESS            = 'LOAD_TRAINING_SUCCESS';
export const UPDATE_TRAINING_ERROR              = 'LOAD_TRAINING_ERROR';

export const DELETE_TRAINING                    = 'LOAD_TRAINING';
export const DELETE_TRAINING_SUCCESS            = 'LOAD_TRAINING_SUCCESS';
export const DELETE_TRAINING_ERROR              = 'LOAD_TRAINING_ERROR';

export const LOAD_TRAINING_TEMPLATES            = 'LOAD_TRAINING_TEMPLATES';
export const LOAD_TRAINING_TEMPLATES_SUCCESS    = 'LOAD_TRAINING_TEMPLATES_SUCCESS';
export const LOAD_TRAINING_TEMPLATES_ERROR      = 'LOAD_TRAINING_TEMPLATES_ERROR';

export const SEARCH_TRAINING_TEMPLATES          = 'SEARCH_TRAINING_TEMPLATES';
export const SELECT_TRAINING_TEMPLATE           = 'SELECT_TRAINING_TEMPLATE';
export const DESELECT_TRAINING_TEMPLATE         = 'DESELECT_TRAINING_TEMPLATE';

export const CREATE_TRAINING_TEMPLATE           = 'CREATE_TRAINING_TEMPLATE';
export const CREATE_TRAINING_TEMPLATE_SUCCESS   = 'CREATE_TRAINING_TEMPLATE_SUCCESS';
export const CREATE_TRAINING_TEMPLATE_ERROR     = 'CREATE_TRAINING_TEMPLATE_ERROR';

export const UPDATE_TRAINING_TEMPLATE           = 'UPDATE_TRAINING_TEMPLATE';
export const UPDATE_TRAINING_TEMPLATE_SUCCESS   = 'UPDATE_TRAINING_TEMPLATE_SUCCESS';
export const UPDATE_TRAINING_TEMPLATE_ERROR     = 'UPDATE_TRAINING_TEMPLATE_ERROR';

export const SAVE_TRAINING_TEMPLATE             = 'SAVE_TRAINING_TEMPLATE';
export const SAVE_TRAINING_TEMPLATE_SUCCESS     = 'SAVE_TRAINING_TEMPLATE_SUCCESS';
export const SAVE_TRAINING_TEMPLATE_ERROR       = 'SAVE_TRAINING_TEMPLATE_ERROR';

export const DELETE_TRAINING_TEMPLATE           = 'DELETE_TRAINING_TEMPLATE';
export const DELETE_TRAINING_TEMPLATE_SUCCESS   = 'DELETE_TRAINING_TEMPLATE_SUCCESS';
export const DELETE_TRAINING_TEMPLATE_ERROR     = 'DELETE_TRAINING_TEMPLATE_ERROR';
